"use client";
import { faEnvelope, faMessage } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Image from "next/image";
import React, { useState } from "react";
import { whatsapp } from "../../../../public/icons";
import { Button } from "react-bootstrap";
import { trackContact } from "../../../utility/UserEvents";
import { sendGTMEvent } from "@next/third-parties/google";
import styles from "../../../styles/ProductDetail.module.css";
import { LeadType } from "../../../Constants/userEventEnums";
import { useUserStore } from "../../../store/User";
import { faPhone } from "@fortawesome/free-solid-svg-icons";
import SendEmail from "../../ProductListing/SendEmail";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import SignInModal from "../../../components/SignInModal";
import OTPModal from "../../../components/User/OTPModal";
import { ViewList } from "../ViewList";
import { useViewListStore } from "../../../store/viewList";
import { fetchItemDetails } from "../../../app/apis/getApis";
import { useQuery } from "@tanstack/react-query";
import { useRouter } from "next/navigation";

const ContactSeller = ({ data, paramId }: any) => {
  const { user, token } = useUserStore((state: any) => state);
  const [emailModal, setEmailModal] = useState<boolean>(false);
  const [signInModal, setSignInModal] = useState(false);
  const [showOTPModal, setShowOTPModal] = useState(false);
  const [otpVerified, setOTPVerified] = useState(false);
  const viewList = useViewListStore((state: any) => state?.viewList);
  const setViewList = useViewListStore((state: any) => state?.setViewList);
  const [isMounted, setIsMounted] = useState(false);

  const router = useRouter();


  const userId = user?.uuid;


  return (
    <>
      <GoogleReCaptchaProvider
        reCaptchaKey={`${process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY}`}
      >
        <div
          className={`${styles.bottomButton} p-2 d-block d-md-none d-lg-none d-xl-none d-xxl-none`}
        >
          <Button
            className="w-100 "
            onClick={() => {
              trackContact(
                data.item.shopTable.shop_id,
                user ? userId : null,
                LeadType.PHONE,
                data?.item?.location?.location_number,
                `${
                  process.env.NEXT_PUBLIC_MARKETPLACE_URL
                }products/${data?.listing_title
                  .replaceAll(" ", "-")
                  .replaceAll("/", "")}-${data?.listing_id}`,
                data.item.shopTable.shop_name
              );
              if (user) {
                window.open(
                  `tel: ${data?.item.shopTable?.on_payment || data?.item?.location?.city?.city_name === "Karachi" ? data?.item?.location?.location_number : "+923104447724"}`,
                  "_self"
                );
              } else {
                setShowOTPModal(true);
              }
              // setShowNumbers(true);
            }}
          >
            <FontAwesomeIcon
              className={`${styles.whatsappIcon} me-2`}
              fontSize={16}
              icon={faPhone}
            />{" "}
            <span className={`fs-14 `}>Contact Seller</span>
          </Button>
          <div className=" w-100 d-flex align-items-center justify-content-between px-2 py-1 ">
            <div
              onClick={() => {
                trackContact(
                  data.item.shopTable.shop_id,
                  user ? userId : null,
                  LeadType.WHATSAPP,
                  data?.item?.location?.location_number,
                  `${
                    process.env.NEXT_PUBLIC_MARKETPLACE_URL
                  }products/${data?.listing_title
                    .replaceAll(" ", "-")
                    .replaceAll("/", "")}-${data?.listing_id}`,
                  data.item.shopTable.shop_id
                );
                window.open(
                  `https://wa.me/${
                    data?.item?.shopTable?.on_payment ||
                    data?.item?.location?.city?.city_name === "Karachi"
                      ? data?.item?.location?.location_number
                          .replace("+92", 92)
                          .replaceAll("-", "")
                      : "+923104447724".replace("+92", 92).replaceAll("-", "")
                  }?text=Hello, I am interested in your item ${data?.url} `
                );
              }}
              className={`d-flex align-items-center  justify-content-center   rounded-1 cursor-pointer `}
            >
              {/* <FontAwesomeIcon
        className={`${styles.whatsappIcon} mx-2`}
        fontSize={20}
        icon={faWhatsapp}
      /> */}
              <Image
                className="mt-1 me-1"
                src={whatsapp}
                alt="whatsapp"
                width={28}
                height={28}
              />
              <span className="text-white">Whatsapp</span>
            </div>
            <div
              onClick={() => {
                // Phone number and default message
                const phoneNumber =
                  data?.item?.shopTable?.on_payment ||
                  data?.item?.location?.city?.city_name === "Karachi"
                    ? data?.item?.location?.location_number
                    : "+923104447724"; // Replace with the actual seller's phone number
                const defaultMessage =
                  "Hello, I am interested in yo ur product. Can we discuss further?";

                // Create the SMS link
                const smsLink = `sms:${phoneNumber}?body=${encodeURIComponent(defaultMessage)}`;

                // Redirect to the SMS app
                window.location.href = smsLink;
              }}
              className={`d-flex align-items-center  justify-content-center   mt-2  mb-2 rounded-1 cursor-pointer`}
            >
              <FontAwesomeIcon
                className={`${styles.emailIcon} text-white `}
                fontSize={22}
                icon={faMessage}
              />
              <span className="ms-1 text-white ">Chat</span>
            </div>
            <div
              onClick={() => {
                sendGTMEvent({
                  event: `Interested-Email`,
                  value: data.item.shopTable.shop_id,
                  action: "cilck",
                  location: "PDP",
                  ListingId: data?.listing_id,
                  shopId: data.item.shopTable.shop_id,
                });
                setEmailModal(true);
              }}
              className={`d-flex align-items-center  justify-content-center   mt-2  mb-2 rounded-1 cursor-pointer`}
            >
              <FontAwesomeIcon
                className={`${styles.emailIcon} text-white `}
                fontSize={22}
                icon={faEnvelope}
              />
              <span className="ms-1 text-white ">Email</span>
            </div>
          </div>

        </div>
        <SendEmail
          shopData={data}
          show={emailModal}
          onHide={() => setEmailModal(false)}
        />
      </GoogleReCaptchaProvider>
      <SignInModal
        // title={title}
        show={signInModal}
        onHide={() => setSignInModal(false)}
      />
      <OTPModal
        show={showOTPModal}
        onHide={() => setShowOTPModal(false)}
        setOTPVerified={setOTPVerified}
        otpVerified={otpVerified}
        shop_name={data?.item?.shopTable?.shop_name}
      />
    </>
  );
};

export default ContactSeller;
